export default __webpack_public_path__ + "static/media/nest.f5153055.jpg";